import React from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@ncoder/ui';
import { CommitList } from '../../molecules/version-control/CommitList';
import { BranchList } from '../../molecules/version-control/BranchList';
import { ReleaseList } from '../../molecules/version-control/ReleaseList';
import { ActionGrid } from '../../molecules/version-control/ActionGrid';
import { CommitData } from '../../atoms/version-control/CommitCard';
import { BranchData } from '../../atoms/version-control/BranchCard';
import { ReleaseData } from '../../atoms/version-control/ReleaseCard';

interface VersionControlTabsProps {
  commits: CommitData[];
  branches: BranchData[];
  releases: ReleaseData[];
  onViewCommitDetails?: (commitId: string) => void;
  onNewCommit?: (message: string, branch: string) => void;
  onSwitchBranch?: (branchName: string) => void;
  onMergeBranch?: (branchName: string) => void;
  onCreatePR?: (branchName: string) => void;
  onCreateBranch?: (branchName: string, fromBranch: string) => void;
  onDownloadRelease?: (releaseName: string) => void;
  onViewReleaseNotes?: (releaseName: string) => void;
  onCreateRelease?: () => void;
  onPush?: () => void;
  onPull?: () => void;
  onSync?: () => void;
  onResolveConflicts?: () => void;
}

export const VersionControlTabs: React.FC<VersionControlTabsProps> = ({
  commits,
  branches,
  releases,
  onViewCommitDetails,
  onNewCommit,
  onSwitchBranch,
  onMergeBranch,
  onCreatePR,
  onCreateBranch,
  onDownloadRelease,
  onViewReleaseNotes,
  onCreateRelease,
  onPush,
  onPull,
  onSync,
  onResolveConflicts,
}) => {
  return (
    <Tabs defaultValue="commits" className="space-y-4">
      <TabsList className="grid w-full grid-cols-4">
        <TabsTrigger value="commits">Commits</TabsTrigger>
        <TabsTrigger value="branches">Branches</TabsTrigger>
        <TabsTrigger value="releases">Releases</TabsTrigger>
        <TabsTrigger value="actions">Actions</TabsTrigger>
      </TabsList>

      <TabsContent value="commits" className="space-y-4">
        <CommitList
          commits={commits}
          branches={branches}
          onViewDetails={onViewCommitDetails}
          onNewCommit={onNewCommit}
        />
      </TabsContent>

      <TabsContent value="branches" className="space-y-4">
        <BranchList
          branches={branches}
          onSwitch={onSwitchBranch}
          onMerge={onMergeBranch}
          onCreatePR={onCreatePR}
          onCreateBranch={onCreateBranch}
        />
      </TabsContent>

      <TabsContent value="releases" className="space-y-4">
        <ReleaseList
          releases={releases}
          onDownload={onDownloadRelease}
          onViewNotes={onViewReleaseNotes}
          onCreateRelease={onCreateRelease}
        />
      </TabsContent>

      <TabsContent value="actions" className="space-y-4">
        <ActionGrid
          onPush={onPush}
          onPull={onPull}
          onSync={onSync}
          onResolveConflicts={onResolveConflicts}
        />
      </TabsContent>
    </Tabs>
  );
};
